import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface PlatformStats {
  total_users: number;
  total_locations: number;
  total_experts: number;
  total_publications: number;
  total_comments: number;
  total_authors: number;
  linkedin_followers: number;
  users_last_30_days: number;
  publications_last_30_days: number;
  calculated_at: string;
}

export function usePlatformStats() {
  return useQuery({
    queryKey: ['platform-stats'],
    queryFn: async (): Promise<PlatformStats | null> => {
      const { data, error } = await supabase
        .from('system_statistics')
        .select('*')
        .order('calculated_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) return null;

      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes client cache
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
}
